import React from "react";
import ReactLoading from "react-loading";
import * as c from "../constants/troubleshooting";

const TestStateIndicator = ( { testState, testError } ) => {
  switch (testState) {
    case c.TestStates.FAIL:
      return (
        <body>
          <h2 style={{ color: "red" }}>Fail</h2>
          <br></br>
          {testError}
        </body>
      );
    case c.TestStates.SUCCESS:
      return <h2 style={{ color: "green" }}>Success</h2>;
    case c.TestStates.LOADING:
      return (
        <ReactLoading type="spin" color="#FFC803" height={50} width={50} />
      );
    default:
      return <div />;
  }
};

export default TestStateIndicator;
